import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { filterList, Filter, Transform } from './filter'

export type UseFiltersProps<T> = {
  filters: Filter[]
  data: T[]
  transform: Transform<T>
}

export const useFilters = <T>({
  filters,
  data,
  transform,
}: UseFiltersProps<T>): T[] => {
  const location = useLocation()
  const searchParams = useMemo(() => {
    return queryString.parse(location.search, {
      arrayFormat: 'bracket',
    })
  }, [location])

  return useMemo(() => {
    return filterList({ filters, data, searchParams, transform })
  }, [filters, data, searchParams, transform])
}
